import { render, staticRenderFns } from "./AddSelectText.vue?vue&type=template&id=0221c198&scoped=true"
import script from "./AddSelectText.vue?vue&type=script&lang=js"
export * from "./AddSelectText.vue?vue&type=script&lang=js"
import style0 from "./AddSelectText.vue?vue&type=style&index=0&id=0221c198&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0221c198",
  null
  
)

export default component.exports